import { render } from "./PDFIcon.vue?vue&type=template&id=d1b4e17e"
import script from "./PDFIcon.vue?vue&type=script&lang=js"
export * from "./PDFIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__